var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3104",
  "data-name": "Group 3104",
  transform: "translate(1284 -211)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2215",
  "data-name": "Rectangle 2215",
  transform: "translate(-1284 224)",
  fill: "none",
  stroke: "#afb6c0",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 3,
  rx: 1.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 15,
  height: 2,
  rx: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2216",
  "data-name": "Rectangle 2216",
  transform: "translate(-1283 218)",
  fill: "none",
  stroke: "#afb6c0",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("path", {
  d: "M1,0H7A0,0,0,0,1,7,0V7A0,0,0,0,1,7,7H0A0,0,0,0,1,0,7V1A1,1,0,0,1,1,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 6,
  height: 6,
  rx: 0.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2217",
  "data-name": "Rectangle 2217",
  transform: "translate(-1276 218)",
  fill: "none",
  stroke: "#afb6c0",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0H6A1,1,0,0,1,7,1V7A0,0,0,0,1,7,7H0A0,0,0,0,1,0,7V0A0,0,0,0,1,0,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 6,
  height: 6,
  rx: 0.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2218",
  "data-name": "Rectangle 2218",
  transform: "translate(-1280 211)",
  fill: "none",
  stroke: "#afb6c0",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("path", {
  d: "M1,0H7A1,1,0,0,1,8,1V7A0,0,0,0,1,8,7H0A0,0,0,0,1,0,7V1A1,1,0,0,1,1,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 7,
  height: 6,
  rx: 0.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2219",
  "data-name": "Rectangle 2219",
  transform: "translate(-1281 220)",
  fill: "#fff",
  stroke: "#afb6c0",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 1,
  rx: 0.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2220",
  "data-name": "Rectangle 2220",
  transform: "translate(-1274 220)",
  fill: "#fff",
  stroke: "#afb6c0",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 1,
  rx: 0.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2221",
  "data-name": "Rectangle 2221",
  transform: "translate(-1278 213)",
  fill: "#fff",
  stroke: "#afb6c0",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 1,
  rx: 0.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 3,
  fill: "none"
})))));
export default __webpack_public_path__ + "static/media/inv.5087d755.svg";
export { SvgComponent as ReactComponent };